// extracted by mini-css-extract-plugin
export default {"addressAndDate":"AddressAndDate_addressAndDate__yNl8Q"};